export const CHARACTER_CREATION_MESSAGE_LIMIT_TRIGGER =
  "message_limit_pre_creation"

export interface MessageLimitResultLike {
  allowed: boolean
  remaining: number
}

export function shouldPreGateCharacterCreationForMessageLimit({
  isAuthenticated,
  isPaid,
  limitResult,
}: {
  isAuthenticated: boolean
  isPaid: boolean
  limitResult?: MessageLimitResultLike | null
}): boolean {
  if (!isAuthenticated || isPaid || !limitResult) return false
  return !limitResult.allowed && limitResult.remaining === 0
}
